/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'profile': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" d="M14.909 14.91a5.455 5.455 0 100-10.91 5.455 5.455 0 000 10.91zM25.818 22.545a5.454 5.454 0 00-5.454-5.454H9.454A5.455 5.455 0 004 22.545V26h21.818v-3.455z" _fill="#fff"/>'
  }
})
